export { default } from './DownloadAppMethod';
export type { SupportedPlatformProps } from './DownloadAppMethod';
